import Utility from "./utility";

//let player;
let isMobile = false;
let youtubePlayers = [];

class VideoBanner {
  public iframeVids: NodeListOf<any>;
  active: boolean;

  constructor(){
    this.init();
  }

  init(){
    this.detectIsMobile();
    //this.iframeVid = document.getElementById("iframe-video-bg");
    this.iframeVids = document.querySelectorAll("[id^=iframe-video-bg]");
    this.iframeVids.forEach(iframe => {
      if (iframe && !iframe.classList.contains('yt-lite')) {
        let videoId = iframe.dataset.id;
        let cookies = document.cookie;
        //console.log("cookies");
        if (videoId) {
          let parentElement = iframe.parentElement;
          let src;
          
          if(isMobile){
            parentElement.classList.contains("in-body") ? src = "data-bg" : src = "data-src-mobile";
            this.updateBgImage(src, videoId);
          } else if (!cookies.includes("consent:yes")) {
            parentElement.classList.contains("in-body") ? src = "data-bg" : src = "data-src-desktop";
            this.updateBgImage("data-src-desktop", videoId);
          } else {
            Utility.loadYouTubeAPI();
          }
        
        }
      }
    });

    let youtubeVideoSources = [];
    let count = 1;
    this.iframeVids.forEach(iframe => {
      if (!iframe || iframe.classList.contains('yt-lite')) {
        //console.log('YouTube API ready');
        return;
      }
      let iframeId = "iframe-video-bg";
      if(iframe.parentElement.classList.contains("in-body")){
        iframeId = `iframe-video-bg-${iframe.dataset.id}`;
      }
      let vid = {};
      vid["id"] = iframe.dataset.id;
      vid["player"] = iframeId;
      youtubeVideoSources.push(vid);
      count++;
    });

    
    (<any>window).onYouTubeIframeAPIReady = () => {
      youtubePlayers = youtubeVideoSources.map(({id, player}) => new YT.Player(player, {
        videoId: id,
          playerVars: {
            autoplay: 1,
            playsinline: 1,
            mute: 1,
            controls: 0,
            showinfo: 0,
            rel: 0,
            modestbranding: 1,
            iv_load_policy: 3,
            playlist: id,
            loop: 1
          },
          events: {
            onReady: this.onPlayerReady,
            onStateChange: this.onPlayerStateChange,
          },
      }))
    };
  }

  //triggered when video player is ready
  async onPlayerReady(event) {
    let playButton = document.getElementById("play-btn");
    let pauseButton = document.getElementById("pause-btn");
    if(playButton != null){
      playButton.addEventListener("click", function () {
        for(const player of youtubePlayers){
          if(player === event.target && player.getPlayerState() === 2){
            player.playVideo();
            pauseButton.classList.remove("d-none");
            playButton.classList.add("d-none");
          }
        } 
      });
    }
    
    if (pauseButton != null) {
      pauseButton.addEventListener("click", function () {
        for(const player of youtubePlayers){
          if(player === event.target && player.getPlayerState() === 1){
            player.pauseVideo();
            playButton.classList.remove("d-none");
            pauseButton.classList.add("d-none");
          }
        } 
      });
    }
    if (playButton != null || pauseButton != null){
      for(const player of youtubePlayers){ 
        if (player.getPlayerState() == 2) {
          playButton.classList.remove("d-none");
          pauseButton.classList.add("d-none");
        } else {
          event.target.playVideo();
          pauseButton.classList.remove("d-none");
          playButton.classList.add("d-none");
        }
      } 
    }
    
  }
  //triggered when the player's state changes.
  onPlayerStateChange(event) {
    if (event.data == window["YT"].PlayerState.ENDED) {
      event.target.playVideo();
    }
  }

  updateBgImage(bgUrl, videoId) {
    let videoContainer = document.querySelector("[id^=yt-video-container]");
    let videoBtns = document.querySelector("[id^=yt-video-banner-btns]");
    let thumbnailImage = document.createElement("img");
    let imageWrapper = document.getElementById("mobile-bg");
    if(imageWrapper != null){
      let imageUrl = imageWrapper.getAttribute(bgUrl);
      
      if(imageUrl != null && imageUrl != ""){
        thumbnailImage.src = imageUrl;
        thumbnailImage.alt = "Video Banner Background";
      }else{
        thumbnailImage.src = "https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg";
        thumbnailImage.alt = "Video Banner Background";
      }
    }else{
      thumbnailImage.src = "https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg";
      thumbnailImage.alt = "Video Banner Background";
    }
    if (videoContainer) {
      videoContainer.classList.add("mobile-iframe-wrapper");
      if (videoBtns) {
        videoBtns.classList.add("d-none");
      }
      videoContainer.appendChild(thumbnailImage);
    }
  };


  detectIsMobile(){
    let vw = window.innerWidth;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      isMobile = true;
    }
    return isMobile;
  }
}
export default VideoBanner;